import { docEntityTypeMap } from "building-types/doc/docEntityTypes";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_127: DocMigration = {
  maxSchemaVersion: "0.0.127",
  description: "Remove instances of deprecated entity types in locked & hidden doc fields",
  apply(json: any) {
    const hiddenEntityCount = Object.keys(json.hidden ?? {}).length;
    const lockedEntityCount = Object.keys(json.locked ?? {}).length;

    if (!hiddenEntityCount && !lockedEntityCount) {
      return json;
    }

    if (hiddenEntityCount) {
      for (const hash in json.hidden) {
        const hiddenEntity = json.hidden[hash];

        if (!docEntityTypeMap[hiddenEntity.type]) {
          delete json.hidden[hash];
        }
      }
    }

    if (lockedEntityCount) {
      for (const hash in json.locked) {
        const lockedEntity = json.locked[hash];

        if (!docEntityTypeMap[lockedEntity.type]) {
          delete json.locked[hash];
        }
      }
    }
    return json;
  },
};

export default migration_0_0_127;
